export default __webpack_public_path__ + "static/Austin-Light-90fae63e93a69c9986ec1d09c90ed65a.woff2";